const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
const usdWhole = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
});
/** "$140.00", or "$140" when the amount is whole dollars. */
export function formatUsd(cents) {
    return cents % 100 === 0 ? usdWhole.format(cents / 100) : usd.format(cents / 100);
}
//# sourceMappingURL=money.js.map